<template>
  <div id="app">
    <Page/>
  </div>
</template>

<script>
import Page from './index.vue'

export default {
  name: 'PULSE',
  components: {
    Page
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  user-select: none;
}
html {
  font-size: 12px;
}
</style>
